import './utils/newRelicBrowser';
import '@tkww/orion-web-app-kernel/init';
import '@tkww/orion-web-ds-global/deprecated/variables.css';
import '@tkww/orion-web-ds-global/deprecated/classes.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import Honeybadger from '@honeybadger-io/js';
import {BrowserRouter} from 'react-router-dom';
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import {ContentProvider} from '@tkww/reg-react-content-provider';
import {PageletHTMLElement} from '@tkww/orion-web-lib-pagelet';
import {UnleashProvider} from './contexts/UnleashContext';
import MembershipGate from './components/MembershipGate';
import {SnackbarContextProvider} from './contexts/SnackbarContext';
import {CoupleContextProvider} from './contexts/CoupleContext';
import {MemberContextProvider} from './contexts/MemberContext';
import {OutOfStockExperimentsContextProvider} from './contexts/OutOfStockExperimentsContext';
import {OnboardingContextProvider} from './contexts/OnboardingContext';
import {PurchasersContextProvider} from './contexts/PurchasersContext';
import {RetailersContextProvider} from './contexts/RetailersContext';
import {SummaryContextProvider} from './contexts/SummaryContext';
import {ItemsContextProvider} from './contexts/ItemsContext';
import {CashFundContextProvider} from './contexts/CashFundContext';
import {AppContextProvider} from './contexts/AppContext';
import {DataSyncContextProvider} from './contexts/DataSyncContext';
import PromptContextFamily from './contexts/PromptContextFamily';
import {QuestionsContextProvider} from './views/Onboarding/contexts/QuestionsContext';
import {ErrorModalProvider} from './views/Onboarding/contexts/ErrorModalContext';
import App from './App';
import {ExperimentsContextProvider} from './contexts/ExperimentsContext';
import filterHoneybadgerNotices from './utils/honeybadger';
import {VenmoAccountContextProvider} from './contexts/VenmoAccountContext';
import {AccountBalancesContextProvider} from './contexts/AccountBalancesContext';
import {StripeAccountContextProvider} from './contexts/StripeAccountContext';

const queryClient = new QueryClient();

const honeyBadgerConf = {
  apiKey: process.env.HONEYBADGER_API_KEY,
  environment: process.env.ENV,
  revision: process.env.VERSION,
  enableUnhandledRejection: false,
  developmentEnvironments: ['qa'],
};

if (
  typeof window !== 'undefined' &&
  window.customElements &&
  !window.customElements.get('ow-pagelet')
) {
  window.customElements.define('ow-pagelet', PageletHTMLElement);
}

Honeybadger.configure(honeyBadgerConf);
Honeybadger.beforeNotify(filterHoneybadgerNotices);

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <BrowserRouter basename={process.env.PUBLIC_URL}>
    <QueryClientProvider client={queryClient}>
      <AppContextProvider>
        <UnleashProvider>
          <MemberContextProvider>
            <CoupleContextProvider>
              <OutOfStockExperimentsContextProvider>
                <ErrorModalProvider>
                  <OnboardingContextProvider>
                    <QuestionsContextProvider>
                      <MembershipGate>
                        <SnackbarContextProvider>
                          <StripeAccountContextProvider>
                            <RetailersContextProvider>
                              <SummaryContextProvider>
                                <ItemsContextProvider>
                                  <PromptContextFamily>
                                    <ExperimentsContextProvider>
                                      {/* Below ExperimentsContextProvider so useFinancialAccounts sees real experiment assignment, not the default context. */}
                                      <PurchasersContextProvider>
                                        <DataSyncContextProvider>
                                          <CashFundContextProvider>
                                            <ContentProvider>
                                              <VenmoAccountContextProvider>
                                                <AccountBalancesContextProvider>
                                                  <App />
                                                </AccountBalancesContextProvider>
                                              </VenmoAccountContextProvider>
                                            </ContentProvider>
                                          </CashFundContextProvider>
                                        </DataSyncContextProvider>
                                      </PurchasersContextProvider>
                                    </ExperimentsContextProvider>
                                  </PromptContextFamily>
                                </ItemsContextProvider>
                              </SummaryContextProvider>
                            </RetailersContextProvider>
                          </StripeAccountContextProvider>
                        </SnackbarContextProvider>
                      </MembershipGate>
                    </QuestionsContextProvider>
                  </OnboardingContextProvider>
                </ErrorModalProvider>
              </OutOfStockExperimentsContextProvider>
            </CoupleContextProvider>
          </MemberContextProvider>
        </UnleashProvider>
      </AppContextProvider>
    </QueryClientProvider>
  </BrowserRouter>,
);
